import React, { useContext, useState, useEffect } from 'react';
import CSVComp from './CSVComp'
import app from '../authentication/firebaseStart';
import styled from 'styled-components';
import { Button } from '@zebra-fed/zds-react-desktop';
import { useTranslation } from "react-i18next";
import DescriptionIcon from '@material-ui/icons/Description';
import CloseIcon from '@material-ui/icons/Close';
import { AuthContext } from '../authentication/Auth';
import { DataContext } from '../data/DataContext';
import CProgress from '../components/CProgress';

const ButtonContainer = styled.div`
    display: flex;
    max-width: 500px;
    justify-content: end;
`;

const CloseIconCustom = styled(CloseIcon)`
    margin-right: 5px;
    &:hover {
        cursor: pointer;
    }
`;


const firestore = app.firestore();
var allDevData = [];
function CSVImport(props) {
    const { cancelClicked = () => { }, importType, ConfigData,
    //isLoadingCsv, sitesData, apsData, devicesData, hasUpdatedTime
    refreshPage = () => { } } = props;
    let { globalAppSettings } = useContext(DataContext);
    const [importedRecords, setImportedRecords] = useState([])
    const [fileInfo, setFileInfo] = useState({})
    const [isParsed, setIsParsed] = useState(false)
    const [clearRecords, setClearRecords] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)
    const [errorMsg, setErrorMsg] = useState("incorrect file")
    const [dataUpdated, setDataUpdated] = useState(false)
    const context = useContext(AuthContext);
    const [totalCsvParts, setTotalCsvParts] = useState(0);
    const [currPercent, setCurrPercent] = useState(0)
    const { t } = useTranslation();
    //const [sitesArr, setSitesArr] = useState([])
    const [firebaseError, setFirebaseError] = useState(false)
    const [testDevData, setTestDevData] = useState([])

    const [hasUpdatedTime,setHasUpdatedTime]=useState(false)

    async function getInitialUpdatedTimeData() {
    let companyID = context.currentUser.claims.companyID;
    let data = (
      await firestore
        .collection("tenants")
        .doc(companyID)
        .collection("Configuration")
        .doc("UpdatedTime")
        .get()
    ).data();

    if (data) {
      setHasUpdatedTime(true)
    } else {
      setHasUpdatedTime(false)
    }
  }
     useEffect(()=>{
       getInitialUpdatedTimeData()
    },[])

    function onImportDone(records, fileInfo, sitesList) {
        setFileInfo(fileInfo);
        //setSitesArr(sitesList)
    }

    function findPercentage(records) {
        let dataSplitLimit2 = 249;
        let convertedJson = records;
        const index = convertedJson.length;
        let count = 0;
        for (let i = 0; i < convertedJson.length; i++) {
            if ((i + 1) % dataSplitLimit2 === 0) {
                count = count + 1;
            }
        }
        if (!(index % dataSplitLimit2) == 0) {
            count = count + 1;
        }
        setTotalCsvParts(count);
    }

    async function importToFirestore(method) {
        console.log("Importing to FS "+method);
        let dataSplitLimit = 249;
        let convertedJson = importedRecords;
        try {
            let batch = firestore.batch();
            const index = convertedJson.length;
            var fakeIndex = 0;
            for (let i = 0; i < convertedJson.length; i++) {
                const doc = convertedJson[i];
                // YOUR UPDATES
                // if ( method === 'ADD') {
                //     await new Promise(r => setTimeout(r, 0.1));
                // }
                console.log("context.currentUser.claims.companyID "+context.currentUser.claims.companyID);
                console.log("doc.ModelNumber + '_' + doc.SerialNumber"+doc.ModelNumber + "_" + doc.SerialNumber)
                let docRef = firestore.collection("tenants")
                    .doc(context.currentUser.claims.companyID)
                    .collection('Devices')
                    .doc(doc.ModelNumber + '_' + doc.SerialNumber);

                var montiorRef = firestore.collection("tenants")
                    .doc(context.currentUser.claims.companyID)
                    .collection('Devices')
                    .doc(doc.ModelNumber + '_' + doc.SerialNumber)
                    .collection('Monitor')
                    .doc('Assignment')

                let excludedSiteDevices = {
                    "modelNumber": doc.ModelNumber.toUpperCase(),
                    "displayModelNumber": doc.ModelNumber,
                    "serialNumber": doc.SerialNumber.toUpperCase(),
                    "displaySerialNumber": doc.SerialNumber,
                    "friendlyName": doc.DeviceFriendlyName.toUpperCase(),
                    "displayDeviceFriendlyName": doc.DeviceFriendlyName,
                    "lastUpdatedAt": Date.now(),
                    "reportedAt": Date.now() //to generate a random number based on time
                    // "siteName": doc.SiteName.toUpperCase(),
                    // "displaySiteName": doc.SiteName
                }
                let includedSiteDevices = {
                    "modelNumber": doc.ModelNumber.toUpperCase(),
                    "displayModelNumber": doc.ModelNumber,
                    "serialNumber": doc.SerialNumber.toUpperCase(),
                    "displaySerialNumber": doc.SerialNumber,
                    "friendlyName": doc.DeviceFriendlyName.toUpperCase(),
                    "displayDeviceFriendlyName": doc.DeviceFriendlyName,
                    "siteName": doc.SiteName.toUpperCase(),
                    "displaySiteName": doc.SiteName,
                    "lastUpdatedAt": Date.now(),
                    "reportedAt": Date.now()
                }

                let findDevicesOld = testDevData.filter(values => (values.displayModelNumber + '_' + values.displaySerialNumber) === (doc.ModelNumber + '_' + doc.SerialNumber))
                let newStrFoundDevicesExcluded = findDevicesOld[0];
                let newStrFoundDevicesIncluded = findDevicesOld[0];

                if (method === 'MODIFY' || method === 'ADD') {
                    if (findDevicesOld.length > 0) {
                        newStrFoundDevicesExcluded["modelNumber"] = doc.ModelNumber.toUpperCase();
                        newStrFoundDevicesExcluded["displayModelNumber"] = doc.ModelNumber;
                        newStrFoundDevicesExcluded["serialNumber"] = doc.SerialNumber.toUpperCase();
                        newStrFoundDevicesExcluded["displaySerialNumber"] = doc.SerialNumber;
                        newStrFoundDevicesExcluded["friendlyName"] = doc.DeviceFriendlyName.toUpperCase();
                        newStrFoundDevicesExcluded["displayDeviceFriendlyName"] = doc.DeviceFriendlyName;
                        newStrFoundDevicesExcluded["lastUpdatedAt"] = Date.now();
                        method === 'ADD' && (newStrFoundDevicesExcluded["reportedAt"] = Date.now());

                        newStrFoundDevicesIncluded["modelNumber"] = doc.ModelNumber.toUpperCase();
                        newStrFoundDevicesIncluded["displayModelNumber"] = doc.ModelNumber;
                        newStrFoundDevicesIncluded["serialNumber"] = doc.SerialNumber.toUpperCase();
                        newStrFoundDevicesIncluded["displaySerialNumber"] = doc.SerialNumber;
                        newStrFoundDevicesIncluded["friendlyName"] = doc.DeviceFriendlyName.toUpperCase();
                        newStrFoundDevicesIncluded["displayDeviceFriendlyName"] = doc.DeviceFriendlyName;
                        newStrFoundDevicesIncluded["lastUpdatedAt"] = Date.now();
                        method === 'ADD' && (newStrFoundDevicesIncluded["reportedAt"] = Date.now());
                        newStrFoundDevicesIncluded["siteName"] = doc.SiteName.toUpperCase();
                        newStrFoundDevicesIncluded["displaySiteName"] = doc.SiteName;

                    }
                    else {
                        newStrFoundDevicesExcluded = excludedSiteDevices;
                        newStrFoundDevicesIncluded = includedSiteDevices;
                    }



                }

                let devicesObjOld = globalAppSettings.deviceRegistrationType === 0 ? newStrFoundDevicesIncluded :
                    globalAppSettings.deviceRegistrationType === 1 ? newStrFoundDevicesExcluded : newStrFoundDevicesIncluded;


                if (method === 'DELETE') {
                    batch.delete(docRef)
                }
                if (method === 'MODIFY') {
                    batch.update(docRef, devicesObjOld)
                }
                if (method === 'ADD') {
                    // batch.update(docRef, devicesObjOld)
                    batch.set(docRef, devicesObjOld, { merge: true })
                }




                let excludedSite = {
                    "friendlyName": doc.DeviceFriendlyName.toUpperCase(),
                    "displayDeviceFriendlyName": doc.DeviceFriendlyName,
                    // "siteName": doc.SiteName.toUpperCase(), // dont update is device registration type == 0 / appsettings
                    // "displaySiteName ": doc.SiteName // dont update is device registration type == 0 / appsettings
                }
                let includedSite = {
                    "friendlyName": doc.DeviceFriendlyName.toUpperCase(),
                    "displayDeviceFriendlyName": doc.DeviceFriendlyName,
                    "siteName": doc.SiteName.toUpperCase(), // dont update is device registration type == 0 / appsettings
                    "displaySiteName": doc.SiteName // dont update is device registration type == 0 / appsettings
                }
                let monitorObj = globalAppSettings.deviceRegistrationType === 0 ? includedSite :
                    globalAppSettings.deviceRegistrationType === 1 ? excludedSite : includedSite;

                if (method === 'DELETE') {
                    batch.delete(montiorRef)
                }
                if (method === 'MODIFY') {
                    batch.set(montiorRef, monitorObj)
                }
                if (method === 'ADD') {
                    batch.set(montiorRef, monitorObj)
                }


                if ((i + 1) % dataSplitLimit === 0) {
                    fakeIndex = fakeIndex + 1;
                    setCurrPercent(Math.round((fakeIndex / totalCsvParts) * 100));
                    await batch.commit()
                    batch = firestore.batch();
                }
            }
            // For committing final batch
            if (!(index % dataSplitLimit) == 0) {
                fakeIndex = fakeIndex + 1;
                setCurrPercent(Math.round((fakeIndex / totalCsvParts) * 100));
                await batch.commit()
            }
            let companyID = context.currentUser.claims.companyID;
            try {
                if (hasUpdatedTime) {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .update({
                            siteInfoUpdated: Date.now()
                        })
                } else {
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('Configuration')
                        .doc('UpdatedTime')
                        .set({
                            siteInfoUpdated: Date.now()
                        })
                }
            } catch (error) {
                console.log("Error "+error);
                setFirebaseError(true)
            }


            setIsLoading(false);
            setDataUpdated(true);
        } catch (error) {
            console.log("Error "+error);
            setFirebaseError(true)
        }

    }


    function handleCancel(value) {
        value === 'DISMISS' && refreshPage();
        cancelClicked();
        setIsParsed(false)
        setClearRecords(true)
        setDataUpdated(false)
        setIsLoading(false)
        setIsLoading2(false)
        setImportedRecords([])
        setFirebaseError(false)
        allDevData = [];
        setTestDevData([]);
    }

    const onClickContinueBtn = () => {
        setIsLoading(true);
        importToFirestore(importType?.value);
    }

    const onParsingStart = (value) => {
        if (value) {
            setIsLoading2(true)
        }
    }
    const getAllDataOnlyDevices = async (lastReported, sitee) => {
        let companyID = context.currentUser.claims.companyID;

        if (sitee) {
            let Query;
            Query = firestore.collection("tenants")
                .doc(companyID)
                .collection('Devices')
                .where('siteName', '==', sitee.toUpperCase())
                .orderBy('reportedAt', 'desc')

            if (lastReported != null) { Query = Query.startAfter(lastReported) }
            const snapshot = (await Query.limit(4000).get());
            let snapshotData = snapshot.docs.map((doc) => doc.data());
            allDevData = allDevData.concat(snapshotData)
            setTestDevData(allDevData)
            lastReported = snapshotData[snapshotData.length - 1]?.reportedAt;
            if (snapshotData.length === 0) {
                setIsLoading2(false)

                return
            }
            getAllDataOnlyDevices(lastReported)

        }

    }

    const onParsingComplete = (results, records) => {
        let getSiteFromRec = [...new Set(records.map(val => val.SiteName))]
        getSiteFromRec.push("LAST_ELEM")
        getSiteFromRec.forEach((vva) => {
            getAllDataOnlyDevices('lastReported', vva)
        })

        if (records?.length > 0) {
            setImportedRecords(records);
            findPercentage(records);
        } else {
            setImportedRecords([])
        }
        setIsParsed(true)
        setClearRecords(false)
    }

    const onClickXButton = () => {
        setIsParsed(false)
        setClearRecords(true)
    }


    return (
        <div>
            <span style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                {
                    firebaseError ?
                        <p>Error Occured. Please retry</p>
                        :
                        isLoading ?
                            <span style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div style={{ display: 'flex', border: '2px solid gainsboro', alignItems: 'center', width: '230px', justifyContent: 'space-between', padding: '5px' }}>
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        <DescriptionIcon style={{ fontSize: '35px' }} />
                                        <span>
                                            <p style={{ margin: '0px', fontSize: '14px' }}>{fileInfo?.name?.length > 20 ? fileInfo?.name?.substring(0, 20) + ".." : fileInfo?.name}</p>
                                            <p style={{ margin: '0px', fontSize: '12px' }}>{fileInfo?.size}</p>
                                        </span>
                                    </span>
                                </div>
                                <CProgress percent={currPercent} />
                            </span>
                            :

                            dataUpdated ? <p>{t('messages.success.success17')}</p>
                                :
                                !isLoading2 && importedRecords.length > 0 && isParsed ?
                                    <div style={{ display: 'flex', border: '2px solid gainsboro', alignItems: 'center', width: '230px', justifyContent: 'space-between', padding: '5px' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <DescriptionIcon style={{ fontSize: '35px' }} />
                                            <span>
                                                <p style={{ margin: '0px', fontSize: '14px' }}>{fileInfo?.name?.length > 20 ? fileInfo?.name?.substring(0, 20) + ".." : fileInfo?.name}</p>
                                                <p style={{ margin: '0px', fontSize: '12px' }}>{fileInfo?.size}</p>
                                            </span>
                                        </span>
                                        <CloseIconCustom onClick={onClickXButton} />

                                    </div>
                                    :

                                    <CSVComp
                                        onImportDone={onImportDone}
                                        onParsingComplete={onParsingComplete}
                                        onParsingStart={onParsingStart}
                                        clearRecords={clearRecords}
                                        errorMsg={errorMsg}
                                        isLoading2={isLoading2}
                                        ConfigData={ConfigData}
                                        importType={importType}
                                    />
                }

            </span>

            <ButtonContainer>
                {
                    firebaseError ?
                        <Button
                            onClick={() => handleCancel('DISMISS')}
                            type="primary"
                            style={{ marginLeft: '0px' }}
                        >
                            {t('dismiss')}
                        </Button>
                        :
                        dataUpdated ?
                            <Button
                                onClick={() => handleCancel('DISMISS')}
                                type="primary"
                                style={{ marginLeft: '0px' }}
                                disabled={!importedRecords.length > 0}
                            >
                                {t('dismiss')}
                            </Button>
                            :
                            <>
                                {
                                    //!isLoadingCsv &&
                                    <>
                                        <Button
                                            onClick={() => handleCancel()}
                                            type="primary"
                                            style={{ marginLeft: '0px', background: 'white', color: 'black', border: '2px solid gray' }}
                                        >
                                            {t('cancel')}
                                        </Button>
                                        <Button
                                            onClick={() => onClickContinueBtn()}
                                            type="primary"
                                            style={{ marginLeft: '0px' }}
                                            disabled={!importedRecords.length > 0 || isLoading}
                                        >
                                            {t('import')}
                                        </Button>
                                    </>
                                }
                            </>

                }
            </ButtonContainer>
        </div>
    )
}

export default CSVImport;